import React from 'react';
import './AdminClonarVoz.css';

const CLONAR_VOZ_URL = (import.meta.env.VITE_CLONE_API_URL || 'http://127.0.0.1:8080').replace(/\/+$/, '');

const AdminClonarVoz = () => (
  <div className="admin-clonar-voz-frame">
    <iframe
      key={CLONAR_VOZ_URL}
      src={`${CLONAR_VOZ_URL}/`}
      title="Clonar-voz (Qwen3-TTS)"
      loading="eager"
      allow="microphone; clipboard-write; fullscreen"
    />
  </div>
);

export default AdminClonarVoz;
